import React, { Component } from 'react';
import PaletteSampleComponent from 'components/palette/PaletteSampleComponent.js';
import {removeSamplePack} from 'actions/index.js';
import { connect } from "react-redux";

class PaletteSamplePackComponent extends Component {
    onClickDelete() {
        this.props.removeSamplePack(this.props.samplePack);
    }

    render() {
        return (
            <div className="palette-sample-pack">
              <div>
              <span className="palette-sample-pack-name">
                {this.props.samplePack.name}
              </span>
              <span
                onClick={() => this.onClickDelete()}
                className="delete-button">x</span>
              </div>
              <div className="palette-sample-pack-samples">
                {this.props.samplePack.samples.map(
                    (sample, i) =>
                        <PaletteSampleComponent
                          key={sample+i}
                          sampleId={sample}
                          slices={this.props.samplePack.sampleToSlices[sample]}
                          i={i}/>)}
              </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        removeSamplePack: samplePack => dispatch(removeSamplePack(samplePack)),
    }
};

export default connect(null, mapDispatchToProps)(PaletteSamplePackComponent);
